var razorpayScript
export default {
  methods: {
    loadRazorpayScriptScript(success = () => { }) {
      if (!razorpayScript) {
        razorpayScript = window.document.createElement('script')
        razorpayScript.src = 'https://checkout.razorpay.com/v1/magic-checkout.js'
        razorpayScript.onload = () => {
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(razorpayScript, head.firstChild)
      } else {
        console.log('Razorpay已加载')
        success && success()
      }
    }
  }
}
